function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import URI from 'urijs';
var instance; // @namespace Model

var Environment = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(Environment, _Backbone$Model);

  function Environment() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Backbone$Model.call.apply(_Backbone$Model, [this].concat(args)) || this; // Return the singleton if it exists, otherwise create the instance

    if (!instance) {
      instance = _assertThisInitialized(_this);
      _this.ios = _this.ios.bind(_assertThisInitialized(_this));
    }

    return instance || _assertThisInitialized(_this);
  }

  var _proto = Environment.prototype;

  _proto.get = function get(key) {
    var val = _Backbone$Model.prototype.get.call(this, key);

    if (val && /_url$/i.test(key)) {
      val = URI(val);
    }

    return val;
  };

  _proto.ios = function ios() {
    return this.get('platform') === 'ios';
  };

  _createClass(Environment, [{
    key: "defaults",
    get: function get() {
      return {
        root_url: URI().host() ? "//" + URI().host() : 'https://pollev.com',
        api_url: URI().host() ? "//" + URI().host() : 'https://www.polleverywhere.com',
        viz_url: URI().host() ? "//" + URI().host() : 'https://viz.polleverywhere.com',
        ssl: URI().protocol() === 'https:',
        firehose_url: '//firehose.polleverywhere.com',
        secure_protocol: 'https',
        image_url_regex: /^https?:\/\/.+\/[^/?]+\.(?:png|jpe?g|gif|image)\??\S*/i,
        image_file_regex: /^https?:\/\/.+\/([^/?]+\.(?:png|jpe?g|gif))\??\S*/i,
        uploaded_image_regex: /^https?:\/\/s3.amazonaws.com\/polleverywhere-images\/.*/i,
        image_bucket_url: 'https://upload-images.polleverywhere.com',
        poll_renderer_url: 'https://poll-renderer.polleverywhere.com',
        nginx_proxy_path: '',
        mobile_url: 'https://pollev.com',
        singularity_url: 'https://beta.polleverywhere.com',
        web_presenter_url: 'https://presenter.polleverywhere.com',

        /*
         * When enabled, Session will use a PPX proxy to get an auth token from
         * www.polleverywhere.com
         */
        token_auth_enabled: false
      };
    }
  }]);

  return Environment;
}(Backbone.Model);

export default Environment;